import type { AnimatedDemo } from '@portfolio/shared';

/**
 * Animated demos shown on the home page.
 *
 * IMPORTANT — attribution: a screen recording on a portfolio reads as "I built
 * this" unless it says otherwise. If a recording came from someone else's
 * project, set `credit` so the page states where it is from. See
 * `docs/content.md`.
 *
 * The caption below describes only what is visible in the recording and makes
 * no claim about who built it, pending confirmation.
 */
export const terminalDemo: AnimatedDemo = {
  id: 'terminal-dashboard',
  src: '/media/terminal-dashboard.gif',
  poster: '/media/terminal-dashboard-poster.png',
  width: 1545,
  height: 796,
  alt: 'Screen recording of a terminal: a Node.js dashboard command is typed at a shell prompt in a git repository, and a text-based dashboard renders in the terminal.',
  caption: 'A Node.js terminal dashboard, rendered entirely with text.',
};
